import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldArrayTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { Button } from '@openng/optimus-ui/button';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';
import { BaseFieldArrayType } from '../base-field-array-type';

interface RepeatProps extends FieldWrapperProps {
  addText?: string;
  addTextValue?: string;
  removeText?: string;

  initialCount?: number;
  maxCount?: number;
  minCount?: number;

  canAdd?: (field: FormlyFieldConfig<RepeatProps>) => boolean;
  canRemove?: (field: FormlyFieldConfig<RepeatProps>, index: number) => boolean;

  disableTopMargin?: boolean;
}

export interface RepeatFieldConfig extends FormlyFieldConfig<RepeatProps> {
  type?: 'repeat' | Type<RepeatTypeComponent>;
}

@Component({
  selector: 'lib-formly-repeat-type',
  templateUrl: './repeat-type.component.html',
  styleUrl: './repeat-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoDirective, NgClass, FormlyModule, Button]
})
export class RepeatTypeComponent extends BaseFieldArrayType<FieldArrayTypeConfig<RepeatProps>> {}
